import React, {PureComponent} from 'react';

import LandingFreelance from './LandingFreelanceUniverse.jsx';

import header from './images/header-purchase.png?size=600';

const metaDescription = "Consultants indépendants en Achats : recevez, consultez et postulez à nos missions de " +
  "management de transition et interim management grâce à notre plateforme";

export default class LandingFreelancePurchase extends PureComponent {
  render() {
    return (
      <LandingFreelance
        headerImg={header.src}
        metaDescription={metaDescription}
        metaTitle="Missions pour professionnels des Achats et Supply Chain"
        sectorText="des achats"
        universeCode="purchase"
      />
    )
  }
}
